import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { Row, Col } from "antd";

import Img from "../../assets/product.png";
import Img1 from "../../assets/center-main.png";
import LipstickImg from "../../assets/lipstick.png";
import { useNavigate } from "react-router-dom";

function Salespromo() {
  const leftRef = useRef(null);
  const middleRef = useRef(null);
  const rightRef = useRef(null);
  const textRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    // ===== ENTRY ANIMATION =====
    gsap.fromTo(
      [leftRef.current, middleRef.current, rightRef.current],
      {
        opacity: 0,
        y: 60,
        scale: 0.95,
      },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power3.out",
      },
    );

    // ===== MIDDLE HOVER TEXT ANIMATION =====
    const middleCard = middleRef.current;

    if (middleCard && textRef.current) {
      gsap.set(textRef.current, { opacity: 0, y: 20 });

      const enter = () => {
        gsap.to(textRef.current, {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: "power2.out",
        });
      };

      const leave = () => {
        gsap.to(textRef.current, {
          opacity: 0.9,
          y: 10,
          duration: 0.4,
        });
      };

      middleCard.addEventListener("mouseenter", enter);
      middleCard.addEventListener("mouseleave", leave);

      return () => {
        middleCard.removeEventListener("mouseenter", enter);
        middleCard.removeEventListener("mouseleave", leave);
      };
    }
  }, []);

  return (
    <section className="salespromo">
      <div className="container">
        <Row gutter={[24, 24]} align="stretch">
          {/* LEFT */}
          <Col xs={24} md={8} style={{ display: "flex" }} ref={leftRef}>
            <div className="productcart">
              <div className="product-1">
                <h3>Best Seller</h3>
                <p>Check out our perfume collection now!</p>
                <button
                  className="shop-btn"
                  onClick={() => navigate("/fragrance?tags=Best+Sales")}
                >
                  SHOP NOW
                </button>
              </div>

              <div className="product-img">
                <img src={Img} alt="Best Seller" />
              </div>
            </div>
          </Col>

          {/* MIDDLE */}
          <Col xs={24} md={8} style={{ display: "flex" }} ref={middleRef}>
            <div className="productcart center-sale">
              <img src={Img1} className="center-images-1" alt="Sale" />

              <div className="product-details" ref={textRef}>
                <p>End This Weekend</p>
                <h3>Big Sale 75% Off</h3>
              </div>
            </div>
          </Col>

          {/* RIGHT */}
          <Col xs={24} md={8} style={{ display: "flex" }} ref={rightRef}>
            <div className="productcart">
              <div className="product-1">
                <h3>Featured Scents</h3>
                <p>Check out our featured perfume collection now!</p>
                <button
                  className="shop-btn"
                  onClick={() => navigate("/fragrance?tags=Featured+Products")}
                >
                  SHOP NOW
                </button>
              </div>

              <div className="product-img">
                <img src={LipstickImg} alt="Featured" />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default Salespromo;
